"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardBadge = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardBadgeMixin = require("../../mixins/components/PropertyCardBadgeMixin");
var StyledPropertyCardBadge = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "StyledPropertyCardBadge",
  componentId: "c11n-8-107-0__sc-tmjrig-0"
})(["", ""], _PropertyCardBadgeMixin.PropertyCardBadgeMixin);
exports.StyledPropertyCardBadge = StyledPropertyCardBadge;